











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamDashInsights_insights",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MostUsedEmojisCard_insights"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingEngagementCard_insights"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TopRetroTemplatesCard_insights"
    }
  ],
  "type": "TeamInsights",
  "abstractKey": null
};

(node ).hash = "f3c4cbf0e3bd7670520e338872beb6fb";

export default node;
